<template>
    <va-create-layout>
        <ShipmentEventOrderFee-form
            :title="title"
            :item="item"
        ></ShipmentEventOrderFee-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
